export default [
  {value: '1', label: '标准品类'},
  {value: '2', label: '自定义品类'}
]
